<template>
  <div
    class="i-navbar-simple"
    :class="{ sticky: props.sticky }"
  >
    <div class="ctnr">
      <div class="wrap">
        <a
          href="#"
          class="logo"
        >
          <img
            :src="logo"
            loading="lazy"
            alt=""
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import logo from "@/assets/logo/logo-dark.svg"

// PROPS
const props = defineProps({
  sticky: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
.i-navbar-simple {
  z-index: $z-index-navbar;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 5px 10px 0 rgb(83 83 83 / 7%);

  &.sticky {
    @media screen and (min-width: $breakpoint-lg) {
      top: 0;
      position: sticky;
    }
  }

  .wrap {
    display: flex;
    padding-top: 8px;
    padding-bottom: 8px;
    justify-content: center;
    align-items: center;

    .logo {
      width: 120px;
      height: 40px;
      padding: 4px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

@media screen and (min-width: $breakpoint-md) {
  .i-navbar-simple {
    .ctnr {
      display: flex;
      width: 90%;
      max-width: 1160px;
      margin-right: auto;
      margin-left: auto;
      flex-direction: column;
      justify-content: center;

      .wrap {
        padding-top: 12px;
        padding-bottom: 12px;

        .logo {
          width: 175px;
          height: 50px;
        }
      }
    }
  }
}
</style>
